import { createRoute } from "@tanstack/solid-router";
import { AchievementsPage } from "@/features/gamification/components/achievements-page";
import { appRoute } from "./route";

/**
 * GAMIFICATION-CORE (UI) — "Logros": racha de lectura (destacada), XP/nivel y
 * consistency badges, derived from local annotations (pure projection).
 * Opt-in and non-punitive; private leagues by default.
 */
export const achievementsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/achievements",
  component: AchievementsPage,
});
